module.exports = __webpack_public_path__ + "img/item_Portrait_01.0cf112de.jpeg";